import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { MeasurementFilter } from 'schemas/MeasurementFilterSchema'
import MeasurementType from 'enums/MeasurementType'
import { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'
import { resolveValueFromMetric } from '../utils/starRatingsUtil'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  starRatings: [
    ...(filter.starRatings || []),
    {
      type: MeasurementType.STAR,
      overallChecked: true,
      values: Array.from(insights).map((insight) =>
        resolveValueFromMetric(insight.name! as MetricCategoryItemStrings)
      )
    } as MeasurementFilter
  ]
})

const generateStarRatingsInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateStarRatingsInsightStrategy
